import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { OnboardingGate } from "@/components/OnboardingGate";
import { CompanyProvider } from "@/lib/CompanyContext";
import Auth from "@/pages/Auth";
import Painel from "@/pages/Painel";
import Quadro from "@/pages/Quadro";
import NovaTarefa from "@/pages/NovaTarefa";
import Execucao from "@/pages/Execucao";
import Resultado from "@/pages/Resultado";
import Briefing from "@/pages/Briefing";
import OnboardingWizard from "@/pages/OnboardingWizard";
import PrimeirosPassos from "@/pages/PrimeirosPassos";
import NovaKb from "@/pages/NovaKb";
import Perfil from "@/pages/Perfil";
import KbDetail from "@/pages/KbDetail";
import Integracoes from "@/pages/Integracoes";
import Automacoes from "@/pages/Automacoes";
import Escala from "@/pages/Escala";
import EscalaWizard from "@/pages/EscalaWizard";
import Consumo from "@/pages/Consumo";
import AdminUsers from "@/pages/AdminUsers";

export default function App() {
  return (
    <Routes>
      <Route path="/auth" element={<Auth />} />
      {/* Primeiros passos roda FORA do Shell (tela cheia, sem menu lateral) —
          é pra onde o OnboardingGate manda quem ainda não fez o onboarding. */}
      <Route
        element={
          <ProtectedRoute>
            <CompanyProvider>
              <Outlet />
            </CompanyProvider>
          </ProtectedRoute>
        }
      >
        <Route path="comecar" element={<PrimeirosPassos />} />
      </Route>
      <Route
        element={
          <ProtectedRoute>
            <CompanyProvider>
              <OnboardingGate>
                <Shell />
              </OnboardingGate>
            </CompanyProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/painel" replace />} />
        <Route path="painel" element={<Painel />} />
        <Route path="quadro" element={<Quadro />} />
        <Route path="nova-tarefa" element={<NovaTarefa />} />
        <Route path="execucao/:id?" element={<Execucao />} />
        <Route path="resultado/:id?" element={<Resultado />} />
        <Route path="perfil" element={<Perfil />} />
        <Route path="briefing" element={<Briefing />} />
        <Route path="briefing/onboarding" element={<OnboardingWizard />} />
        <Route path="briefing/nova" element={<NovaKb />} />
        <Route path="briefing/:kbId" element={<KbDetail />} />
        <Route path="integracoes" element={<Integracoes />} />
        <Route path="automacoes" element={<Automacoes />} />
        <Route path="escala" element={<Escala />} />
        <Route path="escala/wizard" element={<EscalaWizard />} />
        <Route path="consumo" element={<Consumo />} />
        <Route path="admin/users" element={<AdminUsers />} />
      </Route>
      <Route path="*" element={<Navigate to="/painel" replace />} />
    </Routes>
  );
}
